import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapBox: {
    marginTop: 56,
  },
  wrapListImages: {
    marginTop: 16,
  },
  imageWrapper: {
    position: 'relative',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
      transition: 'opacity 0.3s ease',
    },
  },
  image: {
    width: '100%',
    height: 167,
    objectFit: 'cover',
    borderRadius: 0,
  },
  imageLoading: {
    width: '100%',
    height: 167,
    backgroundColor: Colors.Gray3,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: Colors.BlackTransparent4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  overlayText: {
    fontSize: 20,
    fontWeight: 200,
    lineHeight: '30px',
    letterSpacing: 0.8,
    color: Colors.White,
    textAlign: 'center',
  },
}));

export default useStyles;
